const e = {
  name: "Apple",
  dimensions: { width: 34, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 33.6 40" style="enable-background:new 0 0 33.6 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill-rule:evenodd;clip-rule:evenodd;fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M28.1,21.3c0.1,6.1,5.5,8.1,5.5,8.1c0,0.1-0.9,2.9-2.8,5.7c-1.7,2.4-3.5,4.9-6.3,4.9c-2.8,0-3.7-1.6-6.8-1.6
			c-3.2,0-4.2,1.5-6.8,1.6c-2.7,0.1-4.8-2.6-6.5-5.1c-3.6-5-6.3-14.1-2.6-20.2c1.8-3,5-4.9,8.5-5c2.7,0,5.2,1.7,6.8,1.7
			c1.6,0,4.7-2.1,7.9-1.8c1.3,0.1,5.1,0.5,7.6,4C32.3,13.8,28,16.2,28.1,21.3z M22.9,6.4c1.4-1.7,2.4-4,2.1-6.4
			c-2.1,0.1-4.6,1.3-6.1,3c-1.3,1.5-2.5,3.9-2.2,6.2C19.1,9.4,21.4,8.1,22.9,6.4z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Apple
};
